import React from 'react';
import '../../../styles/footer.scss';
// import Logo from '../../../assets//clinical-visuals-logo.png';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const Logo = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";
const FooterMain: React.FC = () => {
  const location = useLocation();

  const entPage = location.pathname === '/ent/videos';
  return (
    <footer className="footermain">
      © 2025 All Rights Reserved.
      {entPage && (
        <Box sx={{ display: "flex", alignItems: "center", marginLeft: 2 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 400, marginRight: 1 }}>
            powered by
          </Typography>
          <Box
            component="img"
            src={Logo}
            alt="Clinical Visuals"
            width={100}
            height={65}
            // sx={{
            //   height: 100,
            //   width: 65,
            // }}
          />
        </Box>
      )}
    </footer>
  );
}

export default FooterMain;